module.exports = __webpack_public_path__ + "static/media/google-drive.b34f3043.svg";